var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.arrayContent),function(text,index){return _c('div',{key:index},[(_vm.isHTML(text))?_c('div',{domProps:{"innerHTML":_vm._s(_vm.getHTML(text,_vm.marginless))}}):(_vm.marginless)?_c('span',[_vm._v(_vm._s(text))]):_c('p',[_vm._v(_vm._s(text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }